import { BuyProgram } from './buy-programs';

export enum LoanOfferTypeEnum {
    Basic,
    Lowest,
    NameYourPayment,
    SelectedCarOffer
}

export interface LoanOffer {
    SessionId?: string;
    VelocifyId?: string;
    ApprovalId?: number;
    ApprovalDate?: string;
    ExpirationDate?: string;
    BuyPrograms?:  BuyProgram[];
    SVCErrorMessage?: string;
    DealId?: number;
    IsBuyProgramExecRequired?: boolean;
    InquiryId?: string;
    BuyProgramType?: any;
    OfferType?: any;
    ApprovedAmount?: number;
    MonthlyPayment?: number;
    APR?: number;
    Terms?: number;
    DownPayment?: number;
    GAPWaiverAmount?: any;
    BuyProgramId?: any;
    BuyProgramIndex?: any;
    Ltv?: any;
    Rate?: any;
    Gap?: any;
    Esc?: any;
    Esctype?: any;
    IsGapSelected?: any;
    PMT?: number;
    ApprovedAmountText?: string;
    IsGAPWaiverSelected?: boolean;
    TemplateName?: string;
    MaximumVehicleMiles?: string | number;
    MinimumVehicleYear?: string | number;
    MaximumAmountFinanced?: string | number;
    MinimumAmountFinanced?: string | number;
}



// WEBPACK FOOTER //
// ./src/app/api/models/loan-offer.ts